module.exports = __webpack_public_path__ + "img/EXV_SD_Nav-Icon_Ausstellerverzeichnis.921ff316.svg";